import { ArrowRight } from "lucide-react";
import { GlassOrb } from "./glass-orb";
import { BookDemoButton } from "./book-demo-dialog";
import { scrollToSection } from "@/lib/cta";

/** What the optional secondary CTA does. */
type SecondaryAction =
  | { kind: "calendly" }
  | { kind: "scroll"; targetId: string }
  | { kind: "link"; href: string };

const secondaryClass =
  "glass-pill px-6 py-3 text-sm font-medium text-white hover:bg-white/10 transition-colors inline-flex items-center";

export function FinalCta({
  heading,
  body,
  primaryCta,
  primaryHref,
  secondaryCta,
  secondary,
}: {
  heading: string;
  body?: string;
  primaryCta: string;
  primaryHref: string;
  secondaryCta?: string;
  secondary?: SecondaryAction;
}) {
  return (
    <section className="relative px-6 py-28 overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, transparent, rgba(43,15,74,0.7) 30%, rgba(11,6,20,0.95)), radial-gradient(60% 60% at 50% 100%, rgba(217,70,239,0.35), transparent 60%)",
        }}
      />
      <div
        aria-hidden
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-80 pointer-events-none"
      >
        <GlassOrb size="lg" />
      </div>
      <div className="relative max-w-3xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-white text-balance mb-5">
          {heading}
        </h2>
        {body && (
          <p className="text-lg text-white/75 max-w-2xl mx-auto mb-10 text-pretty">{body}</p>
        )}
        <div className="flex flex-wrap items-center justify-center gap-3">
          <a
            href={primaryHref}
            className="btn-gradient hover:[--btn-hover:1] hover:btn-gradient-hover px-6 py-3 rounded-full font-medium inline-flex items-center gap-2"
          >
            {primaryCta} <ArrowRight className="size-4" />
          </a>
          {secondaryCta && secondary?.kind === "calendly" && (
            <BookDemoButton variant="ghost">{secondaryCta}</BookDemoButton>
          )}
          {secondaryCta && secondary?.kind === "scroll" && (
            <button
              type="button"
              onClick={() => scrollToSection(secondary.targetId)}
              className={secondaryClass}
            >
              {secondaryCta}
            </button>
          )}
          {secondaryCta && secondary?.kind === "link" && (
            <a href={secondary.href} className={secondaryClass}>
              {secondaryCta}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
